module.exports = __webpack_public_path__ + "static/media/icon_share.56c5f568.svg";